var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 558.85 90.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#c2be00;}.cls-3{fill:#71a95f;}.cls-4{fill:#148b29;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#d4d05f;}.cls-7{fill:#9fc28e;}.cls-8{fill:#74aa61;}.cls-9{clip-path:url(#clip-path-2);}.cls-10{fill:#72a960;}.cls-11{fill:#c3bf00;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -8.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -95.53,
    y: -195.5,
    width: 792,
    height: 612
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 -8.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 8.86,
    width: 78.65,
    height: 81.58
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_header") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.11,88.39,101,60.54h5.69l7.33,27.85h-4.64l-1.71-6.83H99.55l-1.8,6.83ZM100.36,78H107l-3.2-13.73h-.08Z",
    transform: "translate(0 -8.86)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.13,88.39V60.54h5.46l8.12,20.75V60.54h4.21V88.39h-5.45l-8.12-21.3v21.3Z",
    transform: "translate(0 -8.86)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138,88.39l7.92-27.85h5.69l7.33,27.85H154.3l-1.72-6.83h-8.15l-1.79,6.83ZM145.25,78h6.59l-3.19-13.73h-.08Z",
    transform: "translate(0 -8.86)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.79,88.39V60.54h4.44v24.1H177v3.75Z",
    transform: "translate(0 -8.86)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.69,88.39V77.5l-7.17-17h4.95l4.68,12,4.8-12h4.64l-7.45,17V88.39Z",
    transform: "translate(0 -8.86)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196,79.77h4.45v.7q0,5.11,4.56,5.11a4.13,4.13,0,0,0,3.16-1.25,4,4,0,0,0,1.05-2.81,4.68,4.68,0,0,0-1.05-3.24,6.91,6.91,0,0,0-2.93-1.71l-3-1a9.2,9.2,0,0,1-4.44-2.85,7.75,7.75,0,0,1-1.37-4.8,7.36,7.36,0,0,1,2.34-5.81A9.2,9.2,0,0,1,205,60q7.88,0,7.88,7.34V68h-4.45v-.59q0-4-3.9-4c-2.5,0-3.74,1.34-3.74,4a4.07,4.07,0,0,0,.95,2.83A7.78,7.78,0,0,0,205,72.08l3,1.1a9.45,9.45,0,0,1,4.31,2.8,7.2,7.2,0,0,1,1.35,4.57q0,8.39-9.21,8.38c-3.12,0-5.39-.93-6.82-2.81A9.13,9.13,0,0,1,196,80.43Z",
    transform: "translate(0 -8.86)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.67,88.39V60.54h15.06v3.74H222.12V72h10v3.74h-10v8.89H233v3.75Z",
    transform: "translate(0 -8.86)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.15,88.39V60.54h4.45V88.39Z",
    transform: "translate(0 -8.86)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.55,88.39V60.54H280l8.12,20.75V60.54h4.21V88.39h-5.45l-8.12-21.3v21.3Z",
    transform: "translate(0 -8.86)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M297.44,88.39V60.54H312.3v3.74H301.89V72h9.79v3.74h-9.79V88.39Z",
    transform: "translate(0 -8.86)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M324.55,88.93q-4.8,0-7-3.49t-2.21-11q0-7.48,2.21-11c1.47-2.32,3.8-3.49,7-3.49s5.53,1.17,7,3.49,2.2,6,2.2,11-.73,8.65-2.2,11S327.75,88.93,324.55,88.93Zm0-3.35a3.61,3.61,0,0,0,3.39-2c.91-1.72,1.37-4.78,1.37-9.2s-.46-7.32-1.37-9a3.61,3.61,0,0,0-3.39-2,3.54,3.54,0,0,0-3.36,2q-1.4,2.53-1.4,9c0,4.42.47,7.48,1.4,9.2A3.54,3.54,0,0,0,324.55,85.58Z",
    transform: "translate(0 -8.86)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338.16,88.39V60.54H348a7.23,7.23,0,0,1,5,1.64,7,7,0,0,1,2.07,5.54,8.21,8.21,0,0,1-1.17,4.56,4.91,4.91,0,0,1-3.48,2.26v.08c2.79.29,4.24,2.18,4.37,5.69,0,1.33.08,3.21.16,5.66a2.88,2.88,0,0,0,1.33,2.42h-5a5,5,0,0,1-.74-2.46c0-.31-.09-2.07-.19-5.27a5.35,5.35,0,0,0-1-3.35,3.93,3.93,0,0,0-3.1-1H342.6V88.39Zm4.44-15.45h3.55a4.33,4.33,0,0,0,3.28-1.21,4.55,4.55,0,0,0,1.17-3.31q0-4.53-4.21-4.53H342.6Z",
    transform: "translate(0 -8.86)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.76,88.39V60.54h6.95l4.91,20.63h.08l4.83-20.63h6.79V88.39h-4.21V65.22l-5.68,23.17h-3.78L364,65.22V88.39Z",
    transform: "translate(0 -8.86)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M416.81,88.39V60.54h8.82a7.34,7.34,0,0,1,5.84,2.26,8.6,8.6,0,0,1,1.84,5.85,8.3,8.3,0,0,1-2.15,6,8,8,0,0,1-6,2.22h-3.9V88.39Zm4.45-24.5v9.64h3.16q4.44,0,4.44-4.8c0-3.22-1.58-4.84-4.76-4.84Z",
    transform: "translate(0 -8.86)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M437.29,88.39V60.54h9.82a7.26,7.26,0,0,1,5,1.64,7,7,0,0,1,2.06,5.54A8.21,8.21,0,0,1,453,72.28a4.89,4.89,0,0,1-3.47,2.26v.08c2.78.29,4.24,2.18,4.37,5.69,0,1.33.08,3.21.16,5.66a2.9,2.9,0,0,0,1.32,2.42h-5a5,5,0,0,1-.74-2.46c0-.31-.09-2.07-.2-5.27a5.41,5.41,0,0,0-1-3.35,3.94,3.94,0,0,0-3.1-1h-3.63V88.39Zm4.44-15.45h3.55a4.35,4.35,0,0,0,3.28-1.21,4.55,4.55,0,0,0,1.17-3.31c0-3-1.41-4.53-4.21-4.53h-3.79Z",
    transform: "translate(0 -8.86)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M459.28,88.39V60.54h15.06v3.74H463.73V72h10v3.74h-10v8.89h10.92v3.75Z",
    transform: "translate(0 -8.86)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M484,88.39l-6.56-27.85h4.72l4.72,22.23H487l5-22.23h4.72l-7,27.85Z",
    transform: "translate(0 -8.86)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M500.19,88.39V60.54h15.06v3.74H504.64V72h10v3.74h-10v8.89h10.92v3.75Z",
    transform: "translate(0 -8.86)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M519.73,88.39V60.54h5.45l8.12,20.75V60.54h4.21V88.39h-5.45l-8.12-21.3v21.3Z",
    transform: "translate(0 -8.86)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M547.89,88.39V64.28h-6.63V60.54h17.59v3.74h-6.52V88.39Z",
    transform: "translate(0 -8.86)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.62,75.29c-3.55,7.81-4.8,14.87-2.79,15.78s6.5-4.68,10-12.49,2.28-15.83,2.79-15.79a34.68,34.68,0,0,0-10,12.5",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M248.67,75.29c-3.55,7.81-4.8,14.87-2.8,15.78s6.5-4.68,10-12.49,2.28-15.83,2.79-15.79a34.68,34.68,0,0,0-10,12.5",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M401.22,75.29c-3.54,7.81-4.79,14.87-2.79,15.78s6.5-4.68,10.05-12.49,2.28-15.83,2.79-15.79a34.76,34.76,0,0,0-10,12.5",
    transform: "translate(0 -8.86)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83,43.43V55.2H81.33V43.43H78V42h8.27v1.44Z",
    transform: "translate(0 -8.86)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96,42V55.2H94.33V48.83H89.8V55.2H88.17V42H89.8v5.4h4.53V42Z",
    transform: "translate(0 -8.86)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.68,55.2V42h6.83v1.44h-5.2v4.15h4.9V49h-4.9v4.74h5.42V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.41,55.2V42h6.82v1.44H114v4.15h4.9V49H114V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.14,41.73a3.56,3.56,0,0,1,3.49,2.18,11.38,11.38,0,0,1,.76,4.68,11.31,11.31,0,0,1-.76,4.68,3.88,3.88,0,0,1-7,0,11.31,11.31,0,0,1-.76-4.68,11.38,11.38,0,0,1,.76-4.68A3.57,3.57,0,0,1,125.14,41.73Zm0,1.33A2.13,2.13,0,0,0,123,44.69a12.54,12.54,0,0,0-.43,3.9A12.62,12.62,0,0,0,123,52.5a2.2,2.2,0,0,0,4.25,0,12.62,12.62,0,0,0,.43-3.91,12.54,12.54,0,0,0-.43-3.9A2.13,2.13,0,0,0,125.14,43.06Z",
    transform: "translate(0 -8.86)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.74,41.73a3.56,3.56,0,0,1,3.49,2.18,11.38,11.38,0,0,1,.76,4.68,11.31,11.31,0,0,1-.76,4.68,3.88,3.88,0,0,1-7,0,11.31,11.31,0,0,1-.76-4.68,11.38,11.38,0,0,1,.76-4.68A3.57,3.57,0,0,1,135.74,41.73Zm0,1.33a2.13,2.13,0,0,0-2.13,1.63,12.86,12.86,0,0,0-.43,3.9,12.93,12.93,0,0,0,.43,3.91,2.2,2.2,0,0,0,4.25,0,12.62,12.62,0,0,0,.43-3.91,12.54,12.54,0,0,0-.43-3.9A2.13,2.13,0,0,0,135.74,43.06Z",
    transform: "translate(0 -8.86)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.56,55.2V42h3.54a4,4,0,0,1,3.84,1.94,10.29,10.29,0,0,1,.78,4.66c0,4.41-1.48,6.61-4.46,6.61Zm1.63-11.88V53.87h1.7a2.64,2.64,0,0,0,2.63-1.74,9.66,9.66,0,0,0,.5-3.52,10.76,10.76,0,0,0-.44-3.61,2.66,2.66,0,0,0-2.69-1.68Z",
    transform: "translate(0 -8.86)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.25,50.67H166q-.28,4.78-4,4.79a3.56,3.56,0,0,1-3.53-2.19,11.67,11.67,0,0,1-.72-4.68,11.38,11.38,0,0,1,.76-4.68,3.55,3.55,0,0,1,3.49-2.18q3.8,0,3.91,4.11h-1.71c0-1.85-.78-2.78-2.2-2.78a2.13,2.13,0,0,0-2.12,1.63,12.54,12.54,0,0,0-.43,3.9,12.62,12.62,0,0,0,.43,3.91,2.14,2.14,0,0,0,2.12,1.63A2,2,0,0,0,163.82,53,6.18,6.18,0,0,0,164.25,50.67Z",
    transform: "translate(0 -8.86)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168,55.2V42h4.28a3.38,3.38,0,0,1,2.47.88,3.19,3.19,0,0,1,.91,2.43c0,1.89-.68,3-2,3.33v0a1.93,1.93,0,0,1,1.33.71,2.45,2.45,0,0,1,.53,1.49l.12,2.26c0,1.12.28,1.81.7,2.07h-2a3.46,3.46,0,0,1-.45-1.91l-.11-2a2.07,2.07,0,0,0-.7-1.65,2.31,2.31,0,0,0-1.26-.27h-2.2V55.2Zm1.63-11.88V48h1.61a3.61,3.61,0,0,0,1.72-.31,2.35,2.35,0,0,0,1-2.24,2,2,0,0,0-.63-1.54,2.54,2.54,0,0,0-1.76-.57Z",
    transform: "translate(0 -8.86)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.1,55.2V42h1.63V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.65,45.41H188c0-1.56-.69-2.35-2.06-2.35a1.92,1.92,0,0,0-2.18,2.15,2.34,2.34,0,0,0,1.61,2.22l3,1.15a3.16,3.16,0,0,1,1.61,3,3.63,3.63,0,0,1-1.36,3.1,4.41,4.41,0,0,1-2.75.82,3.88,3.88,0,0,1-3.17-1.15,5.16,5.16,0,0,1-.83-3.26h1.63a4.57,4.57,0,0,0,.35,2.09,2.2,2.2,0,0,0,2.13,1,2.26,2.26,0,0,0,1.64-.65,2.3,2.3,0,0,0,.65-1.69,2.38,2.38,0,0,0-1.61-2.25l-3-1.17a3.23,3.23,0,0,1-1.61-3,3.75,3.75,0,0,1,.68-2.27A3.67,3.67,0,0,1,186,41.73C188.37,41.73,189.61,43,189.65,45.41Z",
    transform: "translate(0 -8.86)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.18,55.2V42h1.63V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.72,45.41H202.1c0-1.56-.69-2.35-2.06-2.35a1.92,1.92,0,0,0-2.18,2.15,2.34,2.34,0,0,0,1.61,2.22l3,1.15a3.14,3.14,0,0,1,1.61,3,3.62,3.62,0,0,1-1.35,3.1,4.41,4.41,0,0,1-2.75.82,3.88,3.88,0,0,1-3.17-1.15,5.16,5.16,0,0,1-.83-3.26h1.63a4.57,4.57,0,0,0,.35,2.09,2.2,2.2,0,0,0,2.13,1,2.26,2.26,0,0,0,1.64-.65,2.3,2.3,0,0,0,.65-1.69,2.38,2.38,0,0,0-1.61-2.25l-3-1.17a3.21,3.21,0,0,1-1.61-3,3.75,3.75,0,0,1,.68-2.27A3.66,3.66,0,0,1,200,41.73C202.45,41.73,203.69,43,203.72,45.41Z",
    transform: "translate(0 -8.86)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.9,55.2V42h3.37a5.27,5.27,0,0,1,2.48.48,3.42,3.42,0,0,1,1.61,3.31,3.72,3.72,0,0,1-1.05,2.82,3.79,3.79,0,0,1-2.76,1h-2V55.2Zm1.63-11.88v5h1.94a2.08,2.08,0,0,0,1.57-.66,2.68,2.68,0,0,0,.62-1.91c0-1.59-.77-2.39-2.3-2.39Z",
    transform: "translate(0 -8.86)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.21,55.2V42h4.27a3.4,3.4,0,0,1,2.48.88,3.23,3.23,0,0,1,.91,2.43q0,2.84-2,3.33v0a1.89,1.89,0,0,1,1.33.71,2.46,2.46,0,0,1,.54,1.49l.11,2.26c.05,1.12.28,1.81.7,2.07h-2a3.49,3.49,0,0,1-.44-1.91l-.11-2a2.07,2.07,0,0,0-.71-1.65,2.3,2.3,0,0,0-1.25-.27h-2.21V55.2Zm1.62-11.88V48h1.61a3.61,3.61,0,0,0,1.72-.31,2.35,2.35,0,0,0,1-2.24,2,2,0,0,0-.63-1.54,2.49,2.49,0,0,0-1.75-.57Z",
    transform: "translate(0 -8.86)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.38,55.2V42h6.83v1.44H232v4.15h4.9V49H232v4.74h5.42V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.94,55.2,238.72,42h1.71L243,53.33h0L245.64,42h1.71L244,55.2Z",
    transform: "translate(0 -8.86)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.09,55.2V42h6.82v1.44h-5.2v4.15h4.91V49h-4.91v4.74h5.42V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.13,55.2V42h2.12l4.39,11V42h1.63V55.2H264l-4.26-10.69V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M273.1,43.43V55.2h-1.63V43.43h-3.31V42h8.27v1.44Z",
    transform: "translate(0 -8.86)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.28,55.2V42h1.63V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M286.53,41.73a3.58,3.58,0,0,1,3.5,2.18,11.57,11.57,0,0,1,.75,4.68,11.51,11.51,0,0,1-.75,4.68,3.89,3.89,0,0,1-7,0,11.48,11.48,0,0,1-.76-4.68,11.55,11.55,0,0,1,.76-4.68A3.58,3.58,0,0,1,286.53,41.73Zm0,1.33a2.13,2.13,0,0,0-2.13,1.63,12.93,12.93,0,0,0-.42,3.9,13,13,0,0,0,.42,3.91,2.21,2.21,0,0,0,4.26,0,13,13,0,0,0,.42-3.91,12.93,12.93,0,0,0-.42-3.9A2.14,2.14,0,0,0,286.53,43.06Z",
    transform: "translate(0 -8.86)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M293.19,55.2V42h2.12l4.39,11V42h1.63V55.2h-2.25l-4.26-10.69V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M308.65,55.2V42h2.13l4.39,11V42h1.62V55.2h-2.25l-4.26-10.69V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.51,55.2V42h6.83v1.44h-5.2v4.15H326V49h-4.9v4.74h5.42V55.2Z",
    transform: "translate(0 -8.86)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333,43.43V55.2h-1.62V43.43H328V42h8.27v1.44Z",
    transform: "translate(0 -8.86)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340.31,55.2,337.68,42h1.63l2,10.8h0L343.23,42h2l1.87,10.8h0l2-10.8h1.63L348,55.2h-2l-1.81-10.69h0l-1.9,10.69Z",
    transform: "translate(0 -8.86)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M356.25,41.73a3.57,3.57,0,0,1,3.5,2.18,11.38,11.38,0,0,1,.76,4.68,11.31,11.31,0,0,1-.76,4.68,3.88,3.88,0,0,1-7,0,11.31,11.31,0,0,1-.76-4.68,11.38,11.38,0,0,1,.76-4.68A3.56,3.56,0,0,1,356.25,41.73Zm0,1.33a2.13,2.13,0,0,0-2.12,1.63,12.54,12.54,0,0,0-.43,3.9,12.62,12.62,0,0,0,.43,3.91,2.2,2.2,0,0,0,4.25,0,12.62,12.62,0,0,0,.43-3.91,12.54,12.54,0,0,0-.43-3.9A2.13,2.13,0,0,0,356.25,43.06Z",
    transform: "translate(0 -8.86)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.92,55.2V42h4.27a3.4,3.4,0,0,1,2.48.88,3.22,3.22,0,0,1,.9,2.43c0,1.89-.67,3-2,3.33v0a1.91,1.91,0,0,1,1.33.71,2.52,2.52,0,0,1,.54,1.49l.11,2.26c.05,1.12.28,1.81.7,2.07h-2a3.49,3.49,0,0,1-.44-1.91l-.11-2a2.07,2.07,0,0,0-.71-1.65,2.31,2.31,0,0,0-1.26-.27h-2.2V55.2Zm1.62-11.88V48h1.61a3.61,3.61,0,0,0,1.72-.31,2.35,2.35,0,0,0,1-2.24,2,2,0,0,0-.63-1.54,2.51,2.51,0,0,0-1.75-.57Z",
    transform: "translate(0 -8.86)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M373.09,55.2V42h1.63v6.4l4.59-6.4h1.83l-4,5.51,4.33,7.7h-1.81l-3.57-6.37-1.37,1.87v4.5Z",
    transform: "translate(0 -8.86)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,93.93H1.11l.36,1.74c.06.37.11.74.17,1.12h0c.07-.38.13-.76.22-1.12l.42-1.74h1l.43,1.74c.09.37.16.74.24,1.12H4c.07-.38.11-.75.18-1.12l.36-1.74h1l-.9,3.76H3.32L3,96.19c-.08-.35-.14-.7-.21-1.1h0c-.07.4-.12.75-.19,1.1l-.33,1.5H.94Z",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6,93.93H7.13l.37,1.74c.06.37.1.74.16,1.12h0c.07-.38.13-.76.22-1.12l.42-1.74h1l.42,1.74c.09.37.16.74.24,1.12h0c.07-.38.1-.75.17-1.12l.36-1.74h1l-.9,3.76H9.34L9,96.19c-.08-.35-.14-.7-.21-1.1h0c-.06.4-.12.75-.19,1.1l-.33,1.5H7Z",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12,93.93h1.11l.37,1.74c.06.37.1.74.16,1.12h0c.07-.38.13-.76.23-1.12l.41-1.74h1l.42,1.74c.09.37.16.74.24,1.12h0c.07-.38.11-.75.17-1.12l.36-1.74h1l-.9,3.76H15.36L15,96.19c-.07-.35-.14-.7-.2-1.1h0l-.19,1.1-.34,1.5H13Z",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.07,97.09a.67.67,0,0,1,.67-.71.71.71,0,1,1-.67.71",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.5,94.8H20V94l.5,0v-.2a1.28,1.28,0,0,1,1.39-1.45,2.25,2.25,0,0,1,.75.13l-.2.82a1.4,1.4,0,0,0-.39-.07c-.27,0-.43.15-.43.54v.23h.68v.87h-.68v2.89H20.5Z",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.7,95.81a1.84,1.84,0,1,1,1.84,2,1.86,1.86,0,0,1-1.84-2m2.53,0c0-.65-.23-1.07-.69-1.07s-.69.42-.69,1.07.23,1.07.69,1.07.69-.42.69-1.07",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27,95.81a1.84,1.84,0,1,1,1.84,2,1.85,1.85,0,0,1-1.84-2m2.53,0c0-.65-.24-1.07-.69-1.07s-.7.42-.7,1.07.23,1.07.7,1.07.69-.42.69-1.07",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.24,95.81a1.76,1.76,0,0,1,1.57-2,1.24,1.24,0,0,1,.92.39l0-.58V92.37H34.8v5.32h-.91l-.07-.37h0a1.49,1.49,0,0,1-1,.47c-.93,0-1.54-.75-1.54-2m2.45.72V95a.91.91,0,0,0-.63-.24c-.35,0-.67.33-.67,1s.25,1.08.68,1.08a.73.73,0,0,0,.62-.34",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 35.75,
    y: 86.51,
    width: 1.87,
    height: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.17,97.26l.5-.7a1.61,1.61,0,0,0,1,.4c.33,0,.48-.13.48-.32s-.38-.37-.77-.52-1-.49-1-1.11.57-1.18,1.44-1.18a2.19,2.19,0,0,1,1.33.48l-.5.67a1.39,1.39,0,0,0-.8-.32c-.29,0-.43.11-.43.3s.35.33.74.48,1,.44,1,1.13-.54,1.21-1.55,1.21a2.44,2.44,0,0,1-1.44-.52",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.68,95.81a1.86,1.86,0,0,1,1.78-2,1.59,1.59,0,0,1,1.6,1.81,2.85,2.85,0,0,1,0,.5H42.76a.91.91,0,0,0,1,.79,1.48,1.48,0,0,0,.81-.25l.37.68a2.38,2.38,0,0,1-1.33.42,1.83,1.83,0,0,1-1.91-2m2.43-.41c0-.42-.18-.71-.63-.71a.74.74,0,0,0-.73.71Z",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.67,95.81a1.9,1.9,0,0,1,2-2,1.65,1.65,0,0,1,1.1.41l-.52.72a.81.81,0,0,0-.51-.22c-.54,0-.89.42-.89,1.07s.36,1.07.85,1.07a1.13,1.13,0,0,0,.67-.27l.44.73a1.89,1.89,0,0,1-1.24.44,1.81,1.81,0,0,1-1.86-2",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.38,96.27V93.93H50.5v2.19c0,.54.14.72.47.72s.45-.13.67-.42V93.93h1.11v3.76h-.91l-.08-.52h0a1.47,1.47,0,0,1-1.19.61c-.82,0-1.17-.57-1.17-1.51",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.75,93.93h.92l.07.66h0a1.29,1.29,0,0,1,1.07-.76,1,1,0,0,1,.45.08l-.18,1a1.35,1.35,0,0,0-.41-.07,1,1,0,0,0-.83.7v2.18H53.75Z",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.75,92.79a.65.65,0,0,1,1.29,0,.65.65,0,0,1-1.29,0m.09,1.14H58v3.76H56.84Z",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.11,96.33V94.8h-.52V94l.58,0,.13-1h.92v1h.91v.87h-.91v1.51c0,.43.19.6.49.6a1.35,1.35,0,0,0,.36-.07l.17.81a2.77,2.77,0,0,1-.83.13c-.94,0-1.3-.58-1.3-1.45",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.89,99.09l.2-.85a.85.85,0,0,0,.25.05.64.64,0,0,0,.66-.5l0-.2L61.6,93.93h1.12l.54,1.61c.11.35.2.7.3,1.07h0c.08-.35.17-.71.26-1.07l.45-1.61h1.07l-1.3,3.8c-.36,1-.76,1.44-1.65,1.44a1.56,1.56,0,0,1-.53-.08",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.65,97.09a.68.68,0,1,1,.68.7.68.68,0,0,1-.68-.7",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68,93.93h.91l.08.47h0a1.76,1.76,0,0,1,1.21-.57c.82,0,1.17.58,1.17,1.52v2.34H70.27V95.5c0-.55-.14-.72-.46-.72a.94.94,0,0,0-.7.37v2.54H68Z",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.15,95.81a1.86,1.86,0,0,1,1.78-2,1.59,1.59,0,0,1,1.6,1.81,2.85,2.85,0,0,1,0,.5H73.23a.91.91,0,0,0,1,.79,1.53,1.53,0,0,0,.82-.25l.37.68a2.44,2.44,0,0,1-1.34.42,1.83,1.83,0,0,1-1.91-2m2.43-.41c0-.42-.18-.71-.63-.71a.75.75,0,0,0-.73.71Z",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.51,96.33V94.8H76V94l.57,0,.13-1h.93v1h.9v.87h-.9v1.51c0,.43.19.6.49.6a1.28,1.28,0,0,0,.35-.07l.18.81a2.78,2.78,0,0,1-.84.13c-.93,0-1.3-.58-1.3-1.45",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M45.74,34.55c0,14.19-3,25.69-6.59,25.69s-6.59-11.5-6.59-25.69S40,9.15,39.15,8.86a57.35,57.35,0,0,1,6.59,25.69",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M32.46,51.36c4.16,9.17,5.63,17.46,3.28,18.52S28.11,64.39,24,55.23s-2.67-18.58-3.27-18.52A40.66,40.66,0,0,1,32.46,51.36",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.67,51.36C41.51,60.53,40,68.82,42.39,69.88S50,64.39,54.18,55.23s2.67-18.58,3.27-18.52A40.66,40.66,0,0,0,45.67,51.36",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.67,88.16C22.21,87.33,22,87,21.36,86a19.69,19.69,0,0,0-2.74-3.64,1.83,1.83,0,0,0-1.43-.65v6.45H15V73.59h4.45a5.45,5.45,0,0,1,3.75,1,4,4,0,0,1-2.83,7A7,7,0,0,1,21.73,83c.32.4.81,1,1.34,1.79.69,1,2,2.9,2.3,3.37ZM20.79,75.53a5.81,5.81,0,0,0-1.94-.27H17.19v5.07h1.54a3.92,3.92,0,0,0,2.75-.7,2.57,2.57,0,0,0,.78-2,2.23,2.23,0,0,0-1.47-2.14",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.64,81.56a5.18,5.18,0,0,1-3.34.89H30.67v5.71H28.46V73.58H32.7c2,0,2.93.19,3.78.68a3.92,3.92,0,0,1,2.09,3.55,4.13,4.13,0,0,1-1.93,3.75M35.33,76a3.76,3.76,0,0,0-2.58-.71H30.67V80.8h2.49a2.6,2.6,0,0,0,3-2.75A2.61,2.61,0,0,0,35.33,76",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.85,88.37a6.27,6.27,0,0,1-4.94-2.18A7.87,7.87,0,0,1,40.19,81a8.84,8.84,0,0,1,1-4.34,6.49,6.49,0,0,1,5.72-3.34,6.56,6.56,0,0,1,3.89,1.14l-1.08,1.33a4.76,4.76,0,0,0-2.81-.84A3.84,3.84,0,0,0,43.41,77a8.15,8.15,0,0,0-.76,3.91,7.76,7.76,0,0,0,.58,3.43,4.06,4.06,0,0,0,3.89,2.37,4.65,4.65,0,0,0,2.93-.91l1.08,1.33a7.69,7.69,0,0,1-4.28,1.21",
    transform: "translate(0 -8.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.84,88.15,61.43,84H55.92l-1.38,4.12h-2.3l5.2-14.59h2.77l5.11,14.59Zm-4-12.56h-.13c-.24.83-1.92,6-2.19,6.75H61c-.28-.68-1.94-5.9-2.15-6.75",
    transform: "translate(0 -8.86)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo_header.4300fb33fa9d55f6cd0760a70db8a79e.svg";
export { ForwardRef as ReactComponent };